// 仅框架内且明确声明 embed=1 时进入嵌入态；独立 /index 完全保持原行为。
const params = new URLSearchParams(window.location.search)
export const isEmbedded = window.parent !== window && params.get('embed') === '1'
export const embedHandoff = isEmbedded ? {
  embed: '1', handoff: params.get('handoff'), sourceOrigin: params.get('sourceOrigin')
} : null



// WEBPACK FOOTER //
// ./src/service/embed-mode.js